import React, { useState } from 'react'
import { useDispatch } from "react-redux";
import FilledButton from "../../FilledButton";
import { useForm } from "react-hook-form";
import { updatePatientsListStatus } from "../../../redux/patients/action";


export default function PatientsStatusUpdatePop({ modalVal, handleOpenModal }) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const { handleSubmit } = useForm({ mode: "all" });
    const { Patient_id, status, type } = modalVal
    const updateStatusPatientsList = () => {
        let statusActivity = {
            id: Patient_id,
            status: status ? false : true
        }
        setLoading(true)
        dispatch(updatePatientsListStatus(statusActivity, type)).then(res => {
            if (res.status === 200) {
                setLoading(false)
                handleOpenModal('CommonPop', { header: "Success", body: res?.data?.message, auth: true })
            } else {
                setLoading(false)
                handleOpenModal('CommonPop', { header: "Info", body: res?.data?.message, auth: true })
            }
        }).catch(err => {
            setLoading(false)
            handleOpenModal('CommonPop', { header: "Error", body: err.message, auth: true })
        })
    }
    return (
        <div className='main_delete_modal'>
            <h4>Update A Patient Status?</h4>
            <div className='delete_content'>
                <p>You are about to Update A Patient Status. </p>
            </div>
            <form onSubmit={handleSubmit(updateStatusPatientsList)} className="form_group d_flex justify_content_center form_action delete_modal_btn">
                <FilledButton type="submit" loading={loading} value={'Yes'} className="btn btn_default" loader_class={'btn_loader_red'} />
                <button className="btn btn_primary" type={'reset'} onClick={() => handleOpenModal()}>No</button>
            </form>
        </div>
    )
}
